module.exports = __webpack_public_path__ + "static/3-autosort-teams-3605578579b7da6622574013854d48ee.png";